module.exports = __webpack_public_path__ + "static/media/curve2-bl.2bcd13b4.svg";